import { render } from "./AccountNotificationsForm.vue?vue&type=template&id=7e004036"
import script from "./AccountNotificationsForm.vue?vue&type=script&lang=js"
export * from "./AccountNotificationsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__